// Single source of the user-facing field caption: the Business Term followed by its
// business-term id. Business Terms repeat across groups ("Scheme identifier" x14), so
// the id is what makes a row identifiable on screen.
export default function fieldTitle({
  label,
  ibt,
  ota,
}: { label?: string | undefined; ibt?: string | null | undefined; ota?: string | undefined } = {}): string {
  const term = label || ota || "";
  return ibt ? `${term} - ${ibt}` : term;
}
